/* eslint-disable react/no-unescaped-entities */
import { FC } from 'react';
import Modal from '@common/modal';
import Icon from '@common/assets';
import Colors from '@domain/constant/colors';

import classnames from 'classnames/bind';
import styles from './privacyNotice.module.scss';
const cx = classnames.bind(styles);

interface PrivacyNoticeProps {
  isVisible: boolean;
  onClose: () => void;
  onCheck: () => void;
  contents?: string;
}

const PrivacyNotice: FC<PrivacyNoticeProps> = ({ isVisible, onClose, onCheck, contents }) => {
  if (!contents) return null;

  return (
    <Modal visible={isVisible} onClickBg={onClose}>
      <div className={cx('noticeWrap')}>
        <a className={cx('closeButton')} role="button" onClick={onClose}>
          <Icon name="closeLight" width={24} height={24} fill={Colors.C_COOL_GRAY_90} />
        </a>
        <div dangerouslySetInnerHTML={{ __html: contents }} />
        <a role="button" className={cx('agreeButton')} onClick={onCheck}>
          동의하고 시작하기
        </a>
      </div>
    </Modal>
  );
};

export default PrivacyNotice;
